export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9837.6ac89f24.jpg";